export interface Props {
  fromDate?: Date | null;
  toDate?: Date | null;
}

const defaultData: Props = {
  fromDate: null,
  toDate: null,
};

export class RechargeHistoryFilterModel {
  fromDate?: Date | null;
  toDate?: Date | null;

  constructor(data: Props = defaultData) {
    this.fromDate = data.fromDate || null;
    this.toDate = data.toDate || null;
  }
}
